import { initializeGrid } from "./base"
import { Config } from "../config"

if (document.querySelectorAll(".payments-index").length) {
  if (Config.showLcfsViews) {
    initializeGrid({
      gridName: "book_and_claim_credits",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      }
    })
    initializeGrid({
      gridName: "lcfs_credits",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      }
    })
    initializeGrid({
      gridName: "lcfs_payments",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      }
    })
  } else {
    initializeGrid({gridName: "my_srecs"})
    initializeGrid({gridName: "incentive_payments"})
    initializeGrid({gridName: "srec_payments"})
  }
}
